import React from "react";

import { classNames } from "../../shared/utility";

import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const DEFAULT_INPUT_CLASS =
  "min-h-10 w-full min-w-0 border-0 bg-transparent px-3 py-2 text-sm text-[#0F172A] placeholder:text-[#64748B]/70 focus:outline-none focus:ring-0 disabled:bg-[#F6F8FB] disabled:text-[#64748B]";

const INPUT_GROUP_CLASS =
  "grid w-full grid-cols-[1fr_auto] overflow-hidden rounded-xl border border-[#E2E8F0] bg-white shadow-sm transition focus-within:border-[#2563EB] focus-within:ring-2 focus-within:ring-[#2563EB]/10";

const SEARCH_BUTTON_CLASS =
  "inline-flex min-h-10 shrink-0 items-center justify-center border-l border-[#E2E8F0] bg-[#F8FAFC] px-3 text-[#64748B] transition hover:bg-[#F1F5F9] hover:text-[#0F172A] focus:outline-none focus-visible:bg-[#F1F5F9] disabled:cursor-not-allowed disabled:opacity-50";

export default function InputWithSearch(props) {
  const {
    parentClass,
    className,
    label,
    name,
    onChange,
    type,
    value,
    labelOn,
    error,
    ref,
    labelClass,
    placeholder,
    actionCall,
    disableSearch,
    ...other
  } = props;

  return (
    <div className={classNames("w-full", parentClass)}>
      {labelOn ? (
        <div className="mb-1 flex space-x-2">
          <label
            htmlFor={name}
            className={classNames(
              labelClass ? labelClass : "text-sm",
              "block font-medium text-[#0F172A]",
            )}
          >
            {label}
          </label>
        </div>
      ) : null}
      <div className={INPUT_GROUP_CLASS}>
        <input
          type={type}
          name={name}
          id={name}
          onChange={onChange}
          className={className ? className : DEFAULT_INPUT_CLASS}
          placeholder={placeholder}
          value={value}
          ref={ref}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              actionCall?.();
            }
          }}
          {...other}
        />
        <button
          type="button"
          className={SEARCH_BUTTON_CLASS}
          onClick={actionCall}
          disabled={disableSearch}
          aria-label={`Search ${label || name}`}
        >
          <MagnifyingGlassIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
      {error ? (
        <p className="mt-1 text-xs font-medium text-[#DC2626]">{error}</p>
      ) : null}
    </div>
  );
}
